import { render } from "./DesktopTransactionCard.vue?vue&type=template&id=27cb16de&scoped=true&ts=true"
import script from "./DesktopTransactionCard.vue?vue&type=script&lang=ts"
export * from "./DesktopTransactionCard.vue?vue&type=script&lang=ts"

import "./DesktopTransactionCard.vue?vue&type=style&index=0&id=27cb16de&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cb16de"]])

export default __exports__